import { Link } from "react-router-dom";

export const BrandLogo = ({to = "/dashboard", compact = false, inverse = false}) => {
    const textTone = inverse ? "text-white" : "text-slate-950";
    const subTone = inverse ? "text-white/70" : "text-slate-500";

    return (
        <Link to={to} className="flex shrink-0 items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-md bg-white shadow-sm ring-1 ring-slate-200">
                <img
                    src="/images/ivestclub-logo.png"
                    alt="iVestClub logo"
                    className="h-8 w-8 object-contain"
                />
            </div>
            {!compact && (
                <div className="hidden leading-tight sm:block">
                    <div className={`text-base font-bold tracking-tight ${textTone}`}>
                        <span className="text-[#16a34a]">i</span>
                        <span className="text-[#22c55e]">vest</span>
                        <span className="bg-gradient-to-r from-[#2563eb] to-[#3b82f6] bg-clip-text text-transparent">club</span>
                    </div>
                    <div className={`text-xs font-medium ${subTone}`}>Investor dashboard</div>
                </div>
            )}
        </Link>
    );
}
